import authHeader from "./auth-header";
import axios from "axios";
import { API_URL } from "./constants.service";

class InsuredObjectDataService {
  // Get all insured objects from the database
  getAll(filter) {
    return axios.post(API_URL + "/ships", filter, { headers: authHeader() });
  }

  // Create a new insured object
  create(data) {
    return axios.post(API_URL + "/ship", data, { headers: authHeader() });
  }

  // Get just one insured object
  get(id) {
    return axios.get(API_URL + `/ship/${id}`, { headers: authHeader() });
  }

  // Delete a specific insured object out of the table.
  delete(id) {
    return axios.delete(API_URL + `/ship/${id}`, { headers: authHeader() });
  }

  // Update the data of one specific insured object.
  update(id, data) {
    return axios.put(API_URL + `/ship/${id}`, data, {
      headers: authHeader(),
    });
  }

  // Check if the choosen id exists
  idExists(id) {
    return axios.get(API_URL + `/ship/id-exists/${id}`, { headers: authHeader() });
  }
}

export default new InsuredObjectDataService();
